module.exports = __webpack_public_path__ + "static/media/bigGrayTemplate.78def33a.png";